import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RoleFilterPipe } from './roleFilter.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [RoleFilterPipe],
    providers: [RoleFilterPipe],
    exports: [RoleFilterPipe],
})
export class RoleFilterPipeModule {}
